import { GenerateFields } from '@components/common/Forms/GenerateFields/GenerateFields';
import { CommonFilterForm } from '@type/filters';
import { lastActivity } from '@components/features/filters/helpers/filterObjects';


/**
 * @description Generates the fields for the last activity filter group.
 * * **recordFunc** - the 'record' function from useBjForm.
 * * **submitFunc** - the function to trigger the form submit. You might want to trigger it on blur. Defaults to undefined.
 * * **verticalSpacing** - the spacing between the items. Defaults to 'my-1.5'.
 * * **idPrefix** - the prefix for the form elements ids. When using multiple forms on the same page,
 * this is needed to avoid duplicate ids.
 */
export const LastActivityForm = (props: CommonFilterForm) => {
  // Destructure props
  const {
    recordFunc,
    submitFunc,
    verticalSpacing,
    idPrefix,
  } = props;

  // Render component
  return (
    <GenerateFields
      recordFunc={recordFunc}
      submitFunc={submitFunc}
      filterObject={lastActivity}
      spacing={verticalSpacing}
      idPrefix={idPrefix}
    />
  );
};
